export default __webpack_public_path__ + "static/media/esupport-dark.146cf7fc.svg";